import SectionCard from "./common/SectionCard";
import { getLang } from "../../../store/uiStore";
import "./ReportsRegionsTable.css";

export default function ReportsRegionsTable({ regions }) {
    const lang = getLang();
    const tr = {
        section: lang === "ru" ? "Отчетность по регионам" : "Ҳисоботдиҳӣ аз рӯи минтақаҳо",
        region: lang === "ru" ? "Регион" : "Минтақа",
        clinics: lang === "ru" ? "Клиники" : "Муассисаҳо",
        total: lang === "ru" ? "Всего отчетов" : "Ҳамагӣ ҳисоботҳо",
        submitted: lang === "ru" ? "Представлено" : "Пешниҳодшуда",
        accepted: lang === "ru" ? "Принято" : "Қабулшуда",
        late: lang === "ru" ? "Просрочено" : "Муҳлат гузаштааст",
        performance: lang === "ru" ? "Выполнение" : "Иҷро",
        republic: lang === "ru" ? "Республика" : "Ҷумҳурӣ",
    };
    const getName = (item) => lang === "ru"
        ? (item.name_ru ?? item.name_tj ?? "")
        : (item.name_tj ?? item.name_ru ?? "");

    if (!regions?.length) {
        return null;
    }

    const totals = regions.reduce(
        (acc, region) => ({
            clinics: acc.clinics + (region.clinics || 0),
            total: acc.total + (region.total || 0),
            submitted: acc.submitted + (region.submitted || 0),
            accepted: acc.accepted + (region.accepted || 0),
            returned: acc.returned + (region.returned || 0),
            late: acc.late + (region.late || 0),
            draft: acc.draft + (region.draft || 0),
        }),
        {
            clinics: 0,
            total: 0,
            submitted: 0,
            accepted: 0,
            returned: 0,
            late: 0,
            draft: 0,
        }
    );

    const getReportingPercent = (submitted, total) => {
        if (!total) {
            return 0;
        }

        return ((submitted / total) * 100).toFixed(1);
    };

    return (
        <SectionCard title={tr.section}>

            <div className="table-responsive analytics-table">

                <table className="table table-hover align-middle mb-0">

                    <thead className="table-light">

                        <tr>

                            <th>{tr.region}</th>

                            <th className="text-center">
                                {tr.clinics}
                            </th>

                            <th className="text-center">
                                {tr.total}
                            </th>

                            <th className="text-center">
                                {tr.submitted}
                            </th>

                            <th className="text-center">
                                {tr.accepted}
                            </th>

                            <th className="text-center">
                                {tr.late}
                            </th>

                            <th className="text-center">
                                {tr.performance}
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {regions.map(region => {

                            const reportingPercent =
                                getReportingPercent(
                                    region.submitted,
                                    region.total
                                );

                            return (

                                <tr
                                    key={region.id}
                                    style={{
                                        transition:
                                            "background-color .15s ease",
                                    }}
                                >

                                    <td>

                                        <div className="region-name">

                                            <span className="region-dot" />

                                            {getName(region)}

                                        </div>

                                    </td>

                                    <td className="text-center fw-semibold">

                                        {region.clinics}

                                    </td>

                                    <td className="text-center fw-semibold">

                                        {region.total}

                                    </td>

                                    <td className="text-center">

                                        <span className="report-count submitted">
                                            {region.submitted}
                                        </span>

                                    </td>

                                    <td className="text-center">

                                        <span className="report-count accepted">
                                            {region.accepted}
                                        </span>

                                    </td>

                                    <td className="text-center">

                                        <span className="report-count late">
                                            {region.late}
                                        </span>

                                    </td>

                                    <td className="text-center">

                                        <span className="report-percent">

                                            {reportingPercent}%

                                        </span>

                                    </td>

                                </tr>

                            );
                        })}

                    </tbody>

                    <tfoot>

                        <tr className="table-light fw-bold">

                            <td>
                                {tr.republic}
                            </td>

                            <td className="text-center">
                                {totals.clinics}
                            </td>

                            <td className="text-center">
                                {totals.total}
                            </td>

                            <td className="text-center">
                                {totals.submitted}
                            </td>

                            <td className="text-center">
                                {totals.accepted}
                            </td>

                            <td className="text-center">
                                {totals.late}
                            </td>

                            <td className="text-center">

                                {getReportingPercent(
                                    totals.submitted,
                                    totals.total
                                )}%

                            </td>

                        </tr>

                    </tfoot>

                </table>

            </div>

        </SectionCard>
    );
}
